import { withMetadata } from '../metadata'
import { getExtPrefix as _getExtPrefix } from '../../core/index'

export function getExtPrefix() {
	return withMetadata(_getExtPrefix, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/getExtPrefix.js
// module id = Ek6t
// module chunks = 0 1